/**
 * Харациновые — 5 видов.
 *
 * ⚠️ ПОМЕТКИ «── ГДЕ ВОДИТСЯ ──» ПЕРЕЕХАЛИ СЮДА ВМЕСТЕ С РЫБОЙ. Вторая сотня
 * набиралась по краям света, и в прежнем файле виды стояли блоками: Иберия,
 * Балканы, Восточная Азия. Разрез по семействам эти блоки разнёс бы по
 * девятнадцати файлам, и знание о том, откуда вид, пропало бы вовсе — в коде
 * его больше нигде нет. Поэтому пометка идёт за своей рыбой.
 */
export const ХАРАЦИНОВЫЕ = [
    // ── Тропики и Южное полушарие ──
    {
        id: 'dorado',
        семейство: 'харациновые',
        latin: 'Salminus brasiliensis',
        повадка: 'угонщик',
        minKg: 1.5,
        maxKg: 15,
        typicalKg: 4,
        typicalLengthM: 0.7,
        depthM: 2.5,
        depthBandM: 2,
        сложение: 'прогонистое',
        пасть: 'костистая',
        редкость: 'нечастая',
        когда: 'дневная',
        вода: { мин: 16, опт: 26, макс: 33 },
        течение: 'сильное',
        держится: ['перекат', 'камни', 'бровка'],
        стая: 'малая_стая',
        зубы: true,
        нерест: { с: 11, по: 2 },
        чем: [
            { чем: 'spoon', вес: 1 },
            { чем: 'wobbler', вес: 0.8 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'живец', вес: 0.6 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'jig', вес: 0.4 },
        ],
    },
    {
        id: 'traira',
        семейство: 'харациновые',
        latin: 'Hoplias malabaricus',
        повадка: 'засадный',
        minKg: 0.3,
        maxKg: 4,
        typicalKg: 1,
        typicalLengthM: 0.45,
        depthM: 1.5,
        depthBandM: 1,
        сложение: 'округлое',
        пасть: 'костистая',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 16, опт: 27, макс: 34 },
        течение: 'стоячая',
        держится: ['трава', 'коряги', 'ил'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 11, по: 2 },
        чем: [
            { чем: 'wobbler', вес: 1 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'spinner', вес: 0.8 },
            { чем: 'jig', вес: 0.6 },
            { чем: 'лягушка', вес: 0.6 },
            { чем: 'резка', вес: 0.4 },
        ],
    },
    {
        id: 'tambaqui',
        семейство: 'харациновые',
        latin: 'Colossoma macropomum',
        повадка: 'карповый_силач',
        minKg: 1.5,
        maxKg: 25,
        typicalKg: 5,
        typicalLengthM: 0.7,
        depthM: 3,
        depthBandM: 2,
        сложение: 'высокотелое',
        пасть: 'кожистая',
        редкость: 'обычная',
        когда: 'сумеречная',
        вода: { мин: 20, опт: 28, макс: 35 },
        течение: 'слабое',
        держится: ['коряги', 'трава', 'открытая_вода'],
        стая: 'малая_стая',
        нерест: { с: 11, по: 2 },
        чем: [
            { чем: 'фрукт', вес: 1 },
            { чем: 'пеллетс', вес: 0.8 },
            { чем: 'тесто', вес: 0.6 },
            { чем: 'кукуруза', вес: 0.6 },
            { чем: 'хлеб', вес: 0.4 },
        ],
    },
    {
        id: 'tigerfish',
        семейство: 'харациновые',
        latin: 'Hydrocynus vittatus',
        повадка: 'угонщик',
        minKg: 0.6,
        maxKg: 8,
        typicalKg: 2,
        typicalLengthM: 0.55,
        depthM: 3,
        depthBandM: 2,
        сложение: 'прогонистое',
        пасть: 'костистая',
        редкость: 'обычная',
        когда: 'дневная',
        вода: { мин: 18, опт: 28, макс: 35 },
        течение: 'сильное',
        держится: ['перекат', 'бровка', 'открытая_вода'],
        стая: 'малая_стая',
        зубы: true,
        нерест: { с: 12, по: 2 },
        чем: [
            { чем: 'spoon', вес: 1 },
            { чем: 'резка', вес: 0.8 },
            { чем: 'живец', вес: 0.8 },
            { чем: 'wobbler', вес: 0.6 },
            { чем: 'spinner', вес: 0.6 },
            { чем: 'мушка', вес: 0.6 },
            { чем: 'jig', вес: 0.4 },
        ],
    },
    {
        id: 'goliath_tiger',
        семейство: 'харациновые',
        latin: 'Hydrocynus goliath',
        повадка: 'тропический_гигант',
        minKg: 5,
        maxKg: 35,
        typicalKg: 15,
        typicalLengthM: 1.1,
        depthM: 5,
        depthBandM: 3,
        сложение: 'прогонистое',
        пасть: 'костистая',
        редкость: 'очень_редкая',
        когда: 'дневная',
        вода: { мин: 20, опт: 28, макс: 34 },
        течение: 'сильное',
        держится: ['яма', 'бровка', 'камни'],
        стая: 'одиночка',
        зубы: true,
        нерест: { с: 12, по: 2 },
        чем: [
            { чем: 'живец', вес: 1 },
            { чем: 'резка', вес: 0.8 },
            { чем: 'wobbler', вес: 0.6 },
            { чем: 'spoon', вес: 0.6 },
            { чем: 'jig', вес: 0.4 },
            { чем: 'мушка', вес: 0.2 },
        ],
        краснокнижная: true,
    },
];
//# sourceMappingURL=characids.js.map